import { toast } from "react-toastify"
import { TIME_RESULT } from "../utils/notifications/time"
import { toastUpdate } from "../utils/notifications/toast"
import { translateMessageError } from "../utils/translate/messageErrors"

export const errorHandlerApi = (
    block: any, 
    staticMessage: string,
    setMessageError?: Function,
    toastId?: string
    ): void => {
        
    let msg = ""

    msg = block.error?.message_display 
        ?? block.error?.message

    if(block.status_code === 402) {
        msg = block.message_display
    }

    msg = translateMessageError(msg?.replaceAll(/\"/g, "'")) 
        ?? msg 
        ?? staticMessage 

    if(setMessageError) {
        setMessageError(msg)
    }

    if(toastId) {
        toastUpdate(
            toastId,
            "error",
            TIME_RESULT,
            msg,
        )
    }

} 
